module.exports = __webpack_public_path__ + "assets/7b648e05c63508e8057b0d190a0b4bbf.png";